/* @flow */

export default class DocumentItem {
    name: string;
    cultures: string[];
}

